import React from 'react';
import { useMetaPixel } from './hooks/useMetaPixel';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { CauseSection } from './components/CauseSection';
import { TransformationSection } from './components/TransformationSection';
import { TemplatesSection } from './components/TemplatesSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhoSection } from './components/ForWhoSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { EmotionalClose } from './components/EmotionalClose';
import { Footer } from './components/Footer';
export function App() {
  useMetaPixel('1463044912020912');
  return <div className="min-h-screen bg-cream-100 font-body text-navy-900 selection:bg-gold-500 selection:text-navy-900" data-id="element-0">
      {/* CTA Button above Hero */}

      <HeroSection data-id="element-1" />
      <PainSection data-id="element-2" />
      <CauseSection data-id="element-3" />
      <TransformationSection data-id="element-4" />
      <TemplatesSection data-id="element-5" />
      <TestimonialsSection data-id="element-6" />
      <ForWhoSection data-id="element-7" />
      <HowItWorksSection data-id="element-8" />
      <GuaranteeSection data-id="element-9" />
      <UrgencySection data-id="element-10" />
      <FAQSection data-id="element-11" />
      <EmotionalClose data-id="element-12" />

      <Footer data-id="element-13" />
    </div>;
}